<template>
  <div class="sku-mutiple" @click.stop="goDetail">
    <goodImage
      :img-url="sku.skuImg.imgUrl"
      :image-width="72"
      :custom-style="customStyle"
      :sku-img="skuImg"
    />
    <div class="info">
      <SkuHeader
        :name="sku.skuBase.skuName"
        :sku-format="sku.skuFormats.skuFormat"
      />
      <SkuInfo :sku="sku" :is-open="isOpen" @openChange="openChange" />
      <template v-if="isOpen">
        <SsuInfo
          v-for="(ssu, index) in ssuList"
          :key="index"
          :ssu="ssu"
          :sku="sku"
        />
      </template>
    </div>
  </div>
</template>

<script>
import mixin from '../mixin'
import { mapState } from 'vuex'
import SkuHeader from './SkuHeader.vue'
import SkuInfo from './SkInfo.vue'
import SsuInfo from './SsuInfo.vue'
import { nativeRoutes } from '@/utils/native_interactions/native_redirect/routes'
export default {
  components: {
    SkuHeader,
    SkuInfo,
    SsuInfo
  },
  mixins: [mixin],
  data() {
    return {
      customStyle: {
        with: '1.20rem',
        height: '1.20rem',
        goodImage: {
          'border-radius': '.16rem',
          overflow: 'hidden'
        }
      },
      isOpen: false
    }
  },
  computed: {
    ...mapState('pop', ['shop']),
    ssuList() {
      return this.sku.ssuList
    }
  },
  methods: {
    openChange(value) {
      this.isOpen = value
    },
    goDetail() {
      const ssu = this.ssuList[0]
      this.$track(this.$trackMap.pop.goShopDetail, {
        ssu_id: ssu.ssuId,
        sku_id: ssu.sku_id,
        pop_id: Number(this.shop.id)
      })

      const spm = 'n.314.1223.0'
      const tickReferId = `${spm}.${this.skuIndex}`

      this.$nativeRedirect(nativeRoutes.goodsDetail, {
        id: ssu.ssuId,
        tickReferId
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.sku-mutiple {
  width: 100%;
  padding: 0.16rem 0.24rem 0.2rem 0.32rem;
  overflow: hidden;

  background-color: #fff;
  border-radius: 0.16rem;

  box-sizing: border-box;
  @include flex(row, space-between, flex-start, nowrap);
  .info {
    position: relative;

    width: 0;
    margin-left: 0.16rem;
    box-sizing: border-box;

    flex: auto;
  }
}
</style>
